export const FETCH_USERS_REQUESTED = 'FETCH_USERS_REQUESTED'
export const FETCH_USERS_SUCCEEDED = 'FETCH_USERS_SUCCEEDED'
export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED'

export const UPDATE_SORT_BY = 'UPDATE_SORT_BY'
export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE'

export const FETCH_RESTAURANT_REQUESTED = 'FETCH_RESTAURANT_REQUESTED'
export const FETCH_RESTAURANT_SUCCEEDED = 'FETCH_RESTAURANT_SUCCEEDED'
export const FETCH_RESTAURANT_FAILED = 'FETCH_RESTAURANT_FAILED'

export const UPDATE_FOOD_QTY_IN_FOOD_ITEM = 'UPDATE_FOOD_QTY_IN_FOOD_ITEM'
export const UPDATE_FOOD_QTY_IN_CART = 'UPDATE_FOOD_QTY_IN_CART'

export const MINUS_FOOD_QUANTITY = 'MINUS_FOOD_QUANTITY'
export const CLEAR_QUANTITY = 'CLEAR_QUANTITY'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'

export const DARK_MODE = "DARK_MODE"
export const LIGHT_MODE = "LIGHT_MODE"

export const sortByOptions = [
    {
        id: 0,
        displayText: 'Highest',
        value: 'Highest',
    },
    {
        id: 2,
        displayText: 'Lowest',
        value: 'Lowest',
    },
]
